/* Furry Co. v2 — Theme JavaScript */

document.addEventListener('DOMContentLoaded', function () {

  // Scroll reveal
  const reveals = document.querySelectorAll('.reveal');
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); });
  }, { threshold: 0.1 });
  reveals.forEach(el => revealObserver.observe(el));

  // Sticky header shadow
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 10);
    });
  }

  // Mobile menu toggle
  const toggle = document.querySelector('.mobile-toggle');
  const navLeft = document.querySelector('.header-nav-left');
  const navRight = document.querySelector('.header-nav-right');
  if (toggle) {
    toggle.addEventListener('click', () => {
      [navLeft, navRight].forEach(n => { if (n) n.classList.toggle('mobile-open'); });
    });
  }

  // Product page variant selection
  document.querySelectorAll('.variant-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      this.closest('.variant-options').querySelectorAll('.variant-btn').forEach(b => b.classList.remove('selected'));
      this.classList.add('selected');
    });
  });

  // Product page thumbnails
  document.querySelectorAll('.product-thumbnail').forEach(thumb => {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('.product-thumbnail').forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      const mainImg = document.getElementById('main-product-img');
      if (mainImg && this.dataset.src) mainImg.src = this.dataset.src;
    });
  });

  // Flash message auto-dismiss
  const flash = document.querySelector('.flash-message');
  if (flash) {
    setTimeout(() => {
      flash.style.transition = 'opacity 0.5s';
      flash.style.opacity = '0';
      setTimeout(() => flash.remove(), 500);
    }, 4000);
  }

  // Cart AJAX update
  async function updateCartItem(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    return res.json();
  }

  function updateCartBadge(count) {
    const badge = document.querySelector('.cart-count');
    if (badge) badge.textContent = count;
  }

  // Cart page quantity controls
  document.querySelectorAll('.qty-ctrl-btn').forEach(btn => {
    btn.addEventListener('click', async function () {
      const key = this.dataset.key;
      const row = this.closest('.cart-item');
      const display = row.querySelector('.qty-display');
      const current = parseInt(display.textContent);
      const newQty = this.dataset.action === 'increase' ? current + 1 : Math.max(0, current - 1);
      const cart = await updateCartItem(key, newQty);
      if (newQty === 0) { row.remove(); }
      else { display.textContent = newQty; }
      updateCartBadge(cart.item_count);
      if (cart.item_count === 0) window.location.reload();
    });
  });

  document.querySelectorAll('.cart-remove').forEach(btn => {
    btn.addEventListener('click', async function () {
      const key = this.dataset.key;
      const row = this.closest('.cart-item');
      const cart = await updateCartItem(key, 0);
      row.remove();
      updateCartBadge(cart.item_count);
      if (cart.item_count === 0) window.location.reload();
    });
  });

  // Add to cart (collection & home)
  document.querySelectorAll('.add-to-cart-btn[data-variant-id]').forEach(btn => {
    btn.addEventListener('click', async function () {
      const variantId = this.dataset.variantId;
      if (!variantId) return;
      const original = this.textContent;
      this.disabled = true;
      this.textContent = '✓';
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
        });
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        updateCartBadge(cart.item_count);
      } catch (e) { console.error(e); }
      setTimeout(() => { this.disabled = false; this.textContent = original; }, 1500);
    });
  });

});